import * as z from "zod";

export const putShipmonkIntegration = {
  name: "putShipmonkIntegration" as const,
  input: z.object({
    apiKey: z.string().optional(),
    storeId: z.string(),
    sandboxMode: z.boolean(),
  }),
  output: z.object({}),
};
